import { Col, Container, Row } from 'reactstrap';
import Loader from '../Loader';
import { dynamicImage } from '../../Utils';
import { Outlet } from 'react-router-dom';

export const PublicLayout = () => {
   return (
      <>
         <Loader />
         <div
            style={{
               minHeight: '100vh',
               width: '100vw',
               backgroundImage: 'url("/assets/images/login/confianza.png")',
               backgroundSize: 'cover',
               backgroundPosition: 'center',
               backgroundRepeat: 'no-repeat',
               display: 'flex',
               justifyContent: 'center',
               alignItems: 'center',
            }}
         >
            <Container className="py-5">
               <Row className="justify-content-center">
                  <Col
                     xs={12}
                     md={10}
                     lg={8}
                     xl={6}
                     className="bg-white p-4 rounded shadow"
                  >
                     <div className="text-center mb-4">
                        <img
                           src={dynamicImage(`logo/logo.jpg`)}
                           alt="Logo"
                           style={{ maxWidth: '100px', height: 'auto' }}
                        />
                     </div>
                     <div className="text-center mb-4">
                        <p className="text-muted fst-italic">
                           “Mi Dios, pues, suplirá todo lo que os falta conforme
                           a sus riquezas en gloria en Cristo Jesús.”
                           <br />
                           <strong>– Filipenses 4:19</strong>
                        </p>
                        <p className="mt-3">
                           Este formulario está destinado a quienes necesitan
                           apoyo económico temporal. Por favor, completa cada
                           campo con información veraz para ayudarnos a evaluar
                           tu solicitud de asistencia financiera de forma justa
                           y compasiva.
                        </p>
                     </div>

                     <Outlet />
                  </Col>
               </Row>
            </Container>
         </div>
      </>
   );
};
